import { withOAuth } from "aws-amplify-react";
import React, { Component } from "react";

class OAuthButton extends Component {
  render() {
    const customProvider = process.env.REACT_APP_OAUTH_PROVIDER;
    return (
      <button
        onClick={(e) => this.props.OAuthSignIn(e, customProvider)}
        className="btn-login"
      >
        ¡Vamos!
      </button>
    );
  }
}

export default withOAuth(OAuthButton);
